var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 512,
  height: 512,
  fill: "#2540e5",
  stroke: "hsl(var(--nextui-card))",
  strokeWidth: 0.1,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 20.003-2.834-5.669L-.003 11.5l5.669-2.834L8.5 2.997l2.834 5.669 5.669 2.834-5.669 2.834zM2.233 11.5l4.178 2.089L8.5 17.767l2.089-4.178 4.178-2.089-4.178-2.089L8.5 5.233 6.411 9.411zM18.5 23.989l-1.826-3.651-3.651-1.826 3.651-1.825 1.826-3.652 1.826 3.652 3.651 1.825-3.651 1.826zm-3.241-5.477 2.161 1.081 1.08 2.161 1.08-2.161 2.161-1.081-2.161-1.08-1.08-2.161-1.08 2.161zm4.254-9.497-1.497-2.994-2.993-1.496 2.993-1.497L19.513.036 21.01 3.03l2.993 1.497-2.993 1.496-1.497 2.994Zm-2.254-4.49 1.503.751.751 1.502.751-1.502 1.503-.751-1.503-.751-.751-1.502-.751 1.502z"
})));
export default SvgSparkles;